<div class="voice-text-field w-100">
    <div class="position-relative">
        @if (inputMode === 'textarea') {
            <textarea
                class="form-control"
                [class.form-control-sm]="dense"
                [class.pe-5]="showActionButtons"
                [attr.id]="inputId || null"
                [rows]="rows"
                [placeholder]="placeholder"
                [disabled]="disabled"
                [value]="value"
                (input)="onInput($event)"
                (blur)="notifyTouched()"
            ></textarea>
        } @else {
            <input
                type="text"
                class="form-control"
                [class.form-control-sm]="dense"
                [class.pe-5]="showActionButtons"
                [attr.id]="inputId || null"
                [placeholder]="placeholder"
                [disabled]="disabled"
                [value]="value"
                (input)="onInput($event)"
                (blur)="notifyTouched()"
            />
        }
        @if (showActionButtons) {
            <div class="voice-text-field-actions position-absolute top-0 end-0 d-flex align-items-start p-1">
                @if (showLocationButton) {
                    <button
                        type="button"
                        class="btn btn-link btn-sm py-0 px-1 lh-1 voice-text-field-action-btn"
                        (click)="insertLocation()"
                        [disabled]="disabled || isLocating"
                        title="Insert my current location"
                    >
                        <fa-icon [icon]="isLocating ? spinnerIcon : locationIcon" [class.fa-spin]="isLocating"></fa-icon>
                    </button>
                }
                @if (showClearButton && value) {
                    <button
                        type="button"
                        class="btn btn-link btn-sm text-muted py-0 px-1 lh-1 voice-text-field-action-btn"
                        (click)="clearField()"
                        [disabled]="disabled"
                        title="Clear"
                    >
                        <fa-icon [icon]="clearIcon"></fa-icon>
                    </button>
                }
                @if (showTrailingControls) {
                    @if (!isDictationActive) {
                        <button
                            type="button"
                            class="btn btn-link btn-sm py-0 px-1 lh-1 voice-text-field-action-btn"
                            (click)="startRecording()"
                            [disabled]="disabled"
                            title="Dictate"
                        >
                            <fa-icon [icon]="micIcon"></fa-icon>
                        </button>
                    } @else {
                        <button
                            type="button"
                            class="btn btn-link btn-sm text-danger py-0 px-1 lh-1 voice-text-field-action-btn"
                            (click)="stopRecording()"
                            [disabled]="disabled || isStopping"
                            title="Stop dictation"
                        >
                            <fa-icon [icon]="stopIcon" [class.recording-pulse]="compact && !isStopping"></fa-icon>
                        </button>
                    }
                }
            </div>
        }
    </div>
    @if (!compact) {
        @if (isStopping) {
            <div class="small text-secondary mt-1">
                <fa-icon [icon]="spinnerIcon" class="fa-spin me-1"></fa-icon>
                Stopping…
            </div>
        } @else if (isDictationActive) {
            <div class="small text-success mt-1">
                <fa-icon [icon]="circleIcon" class="recording-pulse me-1"></fa-icon>
                Listening…
            </div>
        } @else if (dictationError) {
            <div class="small text-danger mt-1">{{ dictationError }}</div>
        } @else if (locationError) {
            <div class="small text-danger mt-1">{{ locationError }}</div>
        } @else if (!isDictationSupported) {
            <div class="small text-muted mt-1">Dictation is not supported in this browser. Try Chrome or Edge.</div>
        }
    }
</div>
